var QUERY_CONDITION_TYPE;
(function (QUERY_CONDITION_TYPE) {
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["IN"] = 0] = "IN";
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["LOWER_BOUND"] = 1] = "LOWER_BOUND";
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["UPPER_BOUND"] = 2] = "UPPER_BOUND";
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["BOUND"] = 3] = "BOUND";
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["ONLY"] = 4] = "ONLY";
    QUERY_CONDITION_TYPE[QUERY_CONDITION_TYPE["NOT_IN"] = 5] = "NOT_IN";
})(QUERY_CONDITION_TYPE || (QUERY_CONDITION_TYPE = {}));
export var IorderType;
(function (IorderType) {
    /**
     * 默认比较升序
     */
    IorderType[IorderType["INCREASE"] = 0] = "INCREASE";
    /**
     * 默认比较降序
     */
    IorderType[IorderType["DECREASE"] = 1] = "DECREASE";
    /**
     * 按文本比较升序
     */
    IorderType[IorderType["INCREASE_BY_TEXT"] = 2] = "INCREASE_BY_TEXT";
    /**
     * 按文本比较降序
     */
    IorderType[IorderType["DECREASE_BY_TEXT"] = 3] = "DECREASE_BY_TEXT";
})(IorderType || (IorderType = {}));
var QueryCondition = /** @class */ (function () {
    function QueryCondition() {
        this._conditions = new Array();
        this._limitCount = Number.MAX_VALUE;
        this._offsetCount = 0;
        this._orders = [];
    }
    QueryCondition.newInstance = function () {
        return new QueryCondition();
    };
    QueryCondition.prototype.addCondition = function (column, type, value) {
        var conditionValue = value;
        if (type === QUERY_CONDITION_TYPE.LOWER_BOUND) {
            var condition = value;
            condition.open = condition.open === undefined ? true : condition.open;
            conditionValue = condition;
        }
        else if (type === QUERY_CONDITION_TYPE.UPPER_BOUND) {
            var condition = value;
            condition.open = condition.open === undefined ? true : condition.open;
            conditionValue = condition;
        }
        else if (type === QUERY_CONDITION_TYPE.BOUND) {
            var condition = value;
            condition.lowerOpen = condition.lowerOpen === undefined ? true : condition.lowerOpen;
            condition.upperOpen = condition.upperOpen === undefined ? true : condition.upperOpen;
            conditionValue = condition;
        }
        this._conditions.push({ type: type, column: column, value: conditionValue });
        return this;
    };
    QueryCondition.prototype.index = function (index) {
        this._index = index;
    };
    QueryCondition.prototype.getIndexKey = function () {
        return this._index;
    };
    /**
     * 限制查询个数
     * @param offset 1、默认含义为偏移量，指定要跳过的个数  2、如果count没有传值，那就当做count处理
     * @param count 查询结果最大个数
     */
    QueryCondition.prototype.limit = function (offset, count) {
        if (count === undefined) {
            this._limitCount = offset;
        }
        else {
            this._limitCount = count;
            this._offsetCount = offset;
        }
        if (this._limitCount <= 0) {
            throw new Error('limit size must be opposite value.');
        }
        return this;
    };
    /**
     * 偏移量 指定要跳过多少个
     * @param offset
     */
    QueryCondition.prototype.offset = function (offset) {
        if (offset < 0) {
            throw new Error('offset size must be opposite value or zero.');
        }
        this._offsetCount = offset;
        return this;
    };
    /**
     * 对结果进行排序  先添加的优先级最高
     * @param key
     * @param type
     */
    QueryCondition.prototype.orderby = function (key, type) {
        this._orders.push({
            key: key,
            type: type,
        });
        return this;
    };
    QueryCondition.prototype.hasOrder = function () {
        return this._orders.length > 0;
    };
    QueryCondition.prototype.getOrders = function () {
        return this._orders;
    };
    QueryCondition.prototype.hasIndex = function () {
        return this._index === undefined ? false : true;
    };
    QueryCondition.prototype.limitSize = function () {
        return this._limitCount;
    };
    QueryCondition.prototype.offsetCount = function () {
        return this._offsetCount;
    };
    Object.defineProperty(QueryCondition.prototype, "conditions", {
        get: function () {
            return this._conditions;
        },
        enumerable: true,
        configurable: true
    });
    return QueryCondition;
}());
window.QueryCondition = QueryCondition;
window.QUERY_CONDITION_TYPE = QUERY_CONDITION_TYPE;
export { QueryCondition, QUERY_CONDITION_TYPE };
//# sourceMappingURL=QueryCondition.js.map